module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8638/img/favicon-dark.png"